<div class="client-header">
  <div class="client-info-wrapper">
    <i class="client-icon square-icon fa-duotone fa-solid fa-building-user"></i>

    <div class="client-info">
      <div class="client-name-description">
        <span class="client-name ellipsis">{{ tenant.clientName }}</span>
        <span class="client-description">{{ tenant.clientDescription }}</span>
        <div class="client-id" [oaiboxCopy]="tenant.id">
          {{ tenant.id }}
        </div>
      </div>

      @if (tenant.license && tenant.license.status) {
        <div class="license-info">
          <div>
            License is
            <span class="license-status {{LICENSE_STATUS_CONFIG[tenant.license.status].color}}">
              {{ LICENSE_STATUS_CONFIG[tenant.license.status].label }}
            </span>
          </div>
          @if (tenant.license.status === LicenseStatus.ACTIVE) {
            <div class="license-end-date">
              End Date: {{ tenant.license.endTimestamp | epochToDate | date:'yyyy-MM-dd' }}
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (tenant.registeredMachines.length === 0) {
    <div class="no-machines-info">
      No machines available!
    </div>
  }

  <div class="management-buttons">
    <button class="management-button secondary" oaiboxBsPopover="Configuration Files"
            trigger="hover" container="body" placement="bottom"
            (click)="goToConfigurationFiles()" [oaiboxAuthorizedRoles]="[UserRole.ADMIN]">
      <i class="fa-regular fa-file-code"></i>
    </button>
    <button class="management-button secondary" oaiboxBsPopover="gNB Custom Configuration"
            trigger="hover" container="body" placement="bottom"
            (click)="goToGnbCustomConfiguration()" [oaiboxAuthorizedRoles]="[UserRole.ADMIN]">
      <i class="fa-solid fa-gear"></i>
    </button>
    <button class="management-button warning" oaiboxBsPopover="Update Deployment" trigger="hover"
            container="body" placement="bottom" (click)="updateClient()" [oaiboxAuthorizedRoles]="[UserRole.ADMIN]">
      <i class="fa-solid fa-pen-to-square"></i>
    </button>
    <button class="management-button danger" oaiboxBsPopover="Delete Deployment" trigger="hover"
            container="body" placement="bottom" [oaiboxAuthorizedRoles]="[UserRole.ROOT]"
            (click)="deleteTenant()"><i class="fa-solid fa-trash"></i>
    </button>
    <button [style.visibility]="tenant.registeredMachines.length > 0 ? 'visible' : 'hidden'"
            class="management-button secondary collapsed-toggle"
            (click)="expanded = !expanded">
      <i class="fa-solid" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
  </div>
</div>

@if (tenant.registeredMachines.length > 0) {
  <oaibox-expandable [expanded]="expanded">
    <ul class="machines-list">
      @for (machine of tenant.registeredMachines; track machine.id) {
        <li class="oaibox-telemetry-item">
          <oaibox-oaibox-telemetry [tenant]="tenant" [machine]="machine"></oaibox-oaibox-telemetry>
        </li>
      }
    </ul>
  </oaibox-expandable>
}
